// extracted by mini-css-extract-plugin
export default {"searchIcon":"style_searchIcon__k1Qdw","totalRevenue":"style_totalRevenue__san4q","description":"style_description__dpHkO","totalRevenueRight":"style_totalRevenueRight__2NQTe"};